import { render, staticRenderFns } from "./yuyue_detail.vue?vue&type=template&id=502f3034&scoped=true"
import script from "./yuyue_detail.vue?vue&type=script&lang=js"
export * from "./yuyue_detail.vue?vue&type=script&lang=js"
import style0 from "./yuyue_detail.vue?vue&type=style&index=0&id=502f3034&prod&scoped=true&lang=css"
import style1 from "./yuyue_detail.vue?vue&type=style&index=1&id=502f3034&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502f3034",
  null
  
)

export default component.exports